import React from 'react';
import { Edit2, Trash2, List, Copy } from 'lucide-react';
import { Button } from './Button';

export const OptionsListView = ({ options, onEdit, onDelete, onDuplicate }) => {
  return (
    <div className="overflow-x-auto bg-white rounded-lg shadow">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Choix</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Requis</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {options.map((option) => (
            <tr 
              key={option.id} 
              onClick={() => onEdit(option)}
              className="hover:bg-blue-50 cursor-pointer transition-colors"
            >
              <td className="px-6 py-4">
                <div className="text-sm font-medium text-gray-900">{option.name}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 py-1 text-xs rounded-full font-medium ${
                  option.type === 'single' 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'bg-purple-100 text-purple-700'
                }`}>
                  {option.type === 'single' ? 'Choix unique' : 'Choix multiple'}
                </span>
              </td>
              <td className="px-6 py-4">
                <div className="flex flex-wrap gap-1">
                  {option.choices?.slice(0, 3).map((choice, idx) => (
                    <span key={idx} className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-700">
                      {choice.name}
                      {(choice.price || choice.price_modifier || 0) > 0 && (
                        <span className="ml-1 text-green-600 font-medium">+{(choice.price || choice.price_modifier || 0).toFixed(2)}€</span>
                      )}
                    </span>
                  ))}
                  {option.choices?.length > 3 && (
                    <span className="text-xs text-gray-500">+{option.choices.length - 3} autres</span>
                  )}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                {option.is_required ? (
                  <span className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded-full font-medium">* Requis</span>
                ) : (
                  <span className="text-xs text-gray-400">Optionnel</span>
                )}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" onClick={(e) => e.stopPropagation()}>
                <div className="flex gap-2 justify-end">
                  <Button size="sm" variant="outline" onClick={() => onEdit(option)}>
                    <Edit2 className="w-4 h-4" />
                  </Button>
                  <Button size="sm" variant="outline" onClick={() => onDuplicate(option)}>
                    <Copy className="w-4 h-4" />
                  </Button>
                  <Button size="sm" variant="outline" onClick={() => onDelete(option.id)} className="text-red-600 border-red-300 hover:bg-red-50">
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};